import AssetWrapper, { AssetWrapperProps } from 'atoms/Asset/AssetWrapper';
import Stack from 'atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'atoms/Typography/Typography';
import React from 'react';
import { ImageCardHorizontalContainer } from './ImageCardHorizontal.styles';
import Grid from 'atoms/Layout/Grid/Grid';
import Arrow from 'app/icons/Monospaced/Arrow/Arrow';

export interface ImageCardHorizontalProps {
  href?: string;
  onClick?: () => void;
  image: AssetWrapperProps['imageProps'];
  imageMaxWidth?: AssetWrapperProps['maxWidth'];
  title: TypographyProps;
  supportingText?: TypographyProps;
  className?: string;
}

const ImageCardHorizontal = ({
  href,
  onClick,
  image,
  imageMaxWidth,
  title,
  supportingText,
}: ImageCardHorizontalProps): JSX.Element => (
  <ImageCardHorizontalContainer
    onClick={onClick}
    href={href}
  >
    <Stack
      direction='row'
      gap='spacing-xl'
      align='center'
      justify='center'
    >
      <AssetWrapper
        imageProps={image}
        maxWidth={imageMaxWidth}
        radius='radius-2xl'
      />
      <Stack
        direction='column'
        gap='spacing-sm'
        justify='flex-start'
        align='flex-start'
      >
        <Grid>
          <Stack
            direction='row'
            gap='spacing-xl'
            justify='space-between'
            align='center'
          >
            <Typography {...title} />
            {(href || onClick) && (
              <Arrow
                color='var(--gray-light-400)'
                className='arrow-icon'
                orientation='upRight'
              />
            )}
          </Stack>
        </Grid>
        {supportingText && <Typography {...supportingText} />}
      </Stack>
    </Stack>
  </ImageCardHorizontalContainer>
);

export default ImageCardHorizontal;
